

export class RentalAccessoryApi {
  constructor(api, rentalTransaction) {
    this.api = api;
    this.rentalTransaction = rentalTransaction;
  }

  async setAccessoryQuantities({orgId, trxId, items}) {
    for(let item of items) {
      const quantityChangerId = item.item.quantityChangerId();
      await this.rentalTransaction.setAccessoryQuantity({trxId, id: quantityChangerId, quantity: item.quantity});
    }
  } 

  async addAccessories({orgId, trxId, items}) {
    for(let item of items) {
      const updater = item.item.transactionUpdater(item.quantity);
      await this.rentalTransaction.addAccessory({orgId, trxId, updater});
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/RentalAccessoryApi.js